//import config from '../../public/json/localizations.json';
import { combineReducers } from 'redux';

const LOCALE = process.env.REACT_APP_LOCALE ? process.env.REACT_APP_LOCALE :  'en';

const config = require(`../../public/json/localizations-${LOCALE}.json`);

const locale = (state = config.localizations.default, action) => {
  switch (action.type) {
    case 'SET_LOCALE':
      return state === action.locale ? state : action.locale;
    default:
      return state;
  }
};

const settings = (state = config.settings, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const strings = (
  state = config.localizations[config.localizations.default].strings,
  action
) => {
  switch (action.type) {
    case 'SET_LOCALE':
      return config.localizations[action.locale].strings;
    default:
      return state;
  }
};

const localize = combineReducers({
  locale,
  settings,
  strings,
});

export default localize;



// WEBPACK FOOTER //
// ./src/reducers/localize.js